import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-line bg-white px-4 py-12" data-id="element-167" data-mp="3gfiu2hdxs9dl">
      <div className="mx-auto max-w-4xl text-center" data-id="element-168" data-mp="32nulgo2wc31d">
        <p className="text-lg font-black uppercase tracking-tight text-primary" data-id="element-169" data-mp="32p5qer82vgu2">
          🏠 Entrenamiento en Casa
        </p>
        <p className="mt-3 font-bold text-ink" data-id="element-170" data-mp="36nd1p6jrvpxv">
          El programa completo para entrenar en casa durante 6 meses sin improvisar.
        </p>
        <p className="mt-2 text-sm font-semibold text-ink/60" data-id="element-171" data-mp="38zbay6h7b62">
          Porque tu cuerpo merece un plan que funcione.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-ink/70 sm:flex-row sm:gap-6" data-id="element-172" data-mp="3ldu2qoshwdu8">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="mailto:compradigitalyaa@gmail.com" data-id="element-173" data-mp="29z6ss7ftibds">
            <MailIcon className="h-4 w-4" data-id="element-174" data-mp="2evxbl2j0bl2w" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="https://www.compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-175" data-mp="3lbmtfq7jj4eu">
            <GlobeIcon className="h-4 w-4" data-id="element-176" data-mp="3q7ln9tbn1emn" /> www.compradigitalya.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="https://instagram.com/compradigitalya" target="_blank" rel="noopener noreferrer" data-id="element-177" data-mp="82icbryzq8eb">
            <InstagramIcon className="h-4 w-4" data-id="element-178" data-mp="huo5v64w4xvm" /> @compradigitalya
          </a>
        </div>
        <div className="mt-7 border-t border-line pt-6" data-id="element-179" data-mp="cvtng5au5bc1">
          <p className="text-base font-black text-ink" data-id="element-180" data-mp="qujk5jtqt8zv">
            💪 “El próximo mes puede ser diferente.”
          </p>
          <p className="mt-1 text-sm font-semibold italic text-primary" data-id="element-181" data-mp="mthh0rwpgcsm">
            “¡Finalmente un mes sin abandonar tu entrenamiento!”
          </p>
          <p className="mt-5 text-xs font-semibold text-ink/45" data-id="element-182" data-mp="yto901jxadwu">
            © CompraDigitalYa™ 2026 — Todos los derechos reservados.
            <br data-id="element-183" data-mp="13sirt3hw42gy" />
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}